import React, { Component } from "react";
import { Grid, Row, Col, Image, Button } from "react-bootstrap";
import Carousel from "nuka-carousel";
import createReactClass from "create-react-class";
import Header from "./Header.jsx";
import MembersGrid from "./MembersGrid.jsx"
import hyperlinks from "../../../src/util/hyperlinks";
import nameMapping from "../../../src/util/nameMapping";



export default class HomePage extends Component {
    componentDidMount() {
        // Ensure children of row have consistent height
        // setTimeout(() => {
        //     const rows = document.querySelectorAll(".container > .row");
        //     for (var i = 0; i < rows.length; i++) {
        //         if (rows[i].children.length == 1) continue;
        //         const rowChildren = rows[i].querySelectorAll("div[class^=col-]");
        //         if (rowChildren[0].offsetHeight > rowChildren[1].offsetHeight) {
        //             rowChildren[1].style.height = `${rowChildren[0].offsetHeight}px`;
        //             rowChildren[0].style.height = `${rowChildren[0].offsetHeight}px`;
        //         } else if (rowChildren[0].offsetHeight < rowChildren[1].offsetHeight) {
        //             rowChildren[0].style.height = `${rowChildren[1].offsetHeight}px`;
        //             rowChildren[1].style.height = `${rowChildren[1].offsetHeight}px`;
        //         }
        //     }
        // }, 5);
    }

    render() {
        const advisoryBoardCarouselItems = this.props.advisoryBoard.map((boardMember, i) => {
            return (
                <div key={`carouselItem${i + 1}`}>
                    <a href={hyperlinks["advisoryBoardMembers"]}>
                        <Image src={boardMember.fingerprinted_logo} responsive />
                        <span>
                            <p>{nameMapping[boardMember.short_name] || boardMember.short_name}</p>
                        </span>
                    </a>
                </div>
            );
        });

        const carouselDecorators = [
            {
                component: createReactClass({
                    render() {
                        return <button style={{border: "none", background: "none", fontSize: "24px"}} onClick={this.props.previousSlide}>❮</button>;
                    }
                }),
                position: "CenterLeft",
                style: {
                    padding: 20,
                    top: "40%",
                    left: -60
                }
            },
            {
                component: createReactClass({
                    render() {
                        return <button style={{border: "none", background: "none", fontSize: "24px"}} onClick={this.props.nextSlide}>❯</button>;
                    }
                }),
                position: "CenterRight",
                style: {
                    padding: 20,
                    top: "40%",
                    right: -60
                }
            }
        ];

        const styleForBottomBannerLink = { "position": "absolute", "top": 0, "bottom": 0, "left": 0, "right": "50%" };

        return (
            <Header showCorporateMembers={this.props.showCorporateMembers} flashes={this.props.flashes} currentUser={this.props.currentUser}>
                <h1 style={{ display: "none"}} aria-hidden={true}>Homepage</h1>
                <Grid className="homepage">
                    <Row style={{ display: "flex" }}>
                        <Col md={4}>
                            <div className="who-we-are">
                                <h2>Who We Are</h2>
                                <p>
                                    The <span className="light-blue-text">Leading Utilities of the World</span> is a global network of the world's most <span className="light-blue-text">successful</span> and <span className="light-blue-text">innovative</span> water and wastewater utilities. Membership is the <span className="light-blue-text">gold standard</span> of utility performance.
                                </p>
                                <Button href={hyperlinks["aboutUs"]}>Learn More</Button>
                            </div>
                        </Col>
                        <Col md={8}>
                            <a className="nominate-a-member" href={hyperlinks["newMember"]}>
                                <Image src="/assets/LUOW_5year_logo_wide-833b065e9ec59e9923e9807703c19b602388a0cb0f6ede2344cec6234cb67619.jpg" />
                                <div>Nominate a member</div>
                            </a>
                        </Col>
                    </Row>

                    <Row>
                        <h3 className="our-newest-members">Our Newest Members</h3>
                        <div className="members-grid">
                            <div className="row">
                                <div className="member-card col-md-4">
                                    <div className="member">
                                        <div className="img-wrapper">
                                            <Image src="/assets/barwon_water-fd28286abae0a081cf14112121f3b555d9efb22a4f93e0c7cea21801423c89ce.png" responsive />
                                        </div>
                                    </div>
                                </div>
                                <div className="member-card col-md-4">
                                    <div className="member">
                                        <div className="img-wrapper">
                                            <Image src="/assets/nsva-2c3402c9da51b2bf7a63fc987543fcaffe639c7883fdfd43c654be505701ad86.png" responsive />
                                        </div>
                                    </div>
                                </div>
                                <div className="member-card col-md-4">
                                    <div className="member">
                                        <div className="img-wrapper">
                                            <Image src="/assets/City_of_Vienna-74e8c5ef44e902822aae2ec1083197fedafa72a0b2f9d49336d8413a85c9a97b.svg" responsive />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <a key="membersGridOverlay" href={hyperlinks["currentMembers"]}>
                                <div className="bar">
                                    Meet All Our Members
                                </div>
                            </a>
                            <div className="row">
                                <div className="member-card col-md-4">
                                    <div className="member">
                                        <div className="img-wrapper">
                                            <Image src="/assets/MWD-edf2dd3f12ca7298c8d22e68ef248227769fb3f6bf5409a58b0dcf35f4341b4d.jpg" responsive />
                                        </div>
                                    </div>
                                </div>
                                <div className="member-card col-md-4">
                                    <div className="member">
                                        <div className="img-wrapper">
                                            <Image src="/assets/mekorot-f4acabe519230b95f4c1915efbdb7059d3ab1c698d6cab6ead4336fa9f288539.jpg" responsive />
                                        </div>
                                    </div>
                                </div>
                                <div className="member-card col-md-4">
                                    <div className="member">
                                        <div className="img-wrapper">
                                            <Image src="/assets/vitens-586235a863cd046efda7f896bdd389e5adf44520e68105cc7e615b5949bc9c0e.png" responsive />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row"></div>
                        </div>
                    </Row>

                    <Row className="advisory-board-and-become-a-partner video-row">
                        <Col md={8}>
                            <div className="video-container">
                                <div>
                                    <iframe src="https://player.vimeo.com/video/712607166?h=f96c149a80" width="700" height="394" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>
                                </div>
                            </div>
                        </Col>
                        <Col md={4}>
                            <div className="become-a-partner">
                                <h2>Download The LUOW Digital Brochure</h2>
                                <div>
                                  <p>
                                      Download the LUOW digital brochure and find out more.
                                  </p>
                                </div>
                                <Button href={hyperlinks["digitalBrochure"]}>Download</Button>
                            </div>
                        </Col>
                    </Row>

                    <Row className="advisory-board-and-become-a-partner">
                        <Col md={8}>
                            <div className="advisory-board">
                                <a href={hyperlinks["advisoryBoardMembers"]}>
                                    <h2>The Advisory Board</h2>
                                </a>
                                <Carousel
                                    slidesToShow={4}
                                    speed={600}
                                    cellSpacing={15}
                                    autoplay={true}
                                    autoplayInterval={4000}
                                    wrapAround={true}
                                    decorators={carouselDecorators}
                                >
                                    {advisoryBoardCarouselItems}
                                </Carousel>
                            </div>
                        </Col>
                        <Col md={4}>
                            <div className="become-a-partner">
                                <h2>Become A Corporate Member</h2>
                                <div>
                                  <p>
                                      Help us celebrate <span className="light-blue-text">outstanding achievement</span> in the global water sector and <span className="light-blue-text">drive performance</span> across the sector.
                                  </p>
                                </div>
                                <Button href={hyperlinks["corporateMembership"]}>Learn More</Button>
                            </div>
                        </Col>
                    </Row>

                    <Row className="end-page-logos">
                      <Col md={12}>
                        <Row>
                          <a style={styleForBottomBannerLink} href={hyperlinks["home"]}>&nbsp;</a>
                          <a href={hyperlinks["foundationPartner"]}>
                            <Image src="/assets/Jacobs-banner-9068cd607db6e9986839258416ffd88a8f03b6ac19c8972c6afaf0d2fc5eae6b.svg" className="bottom-partner-logo" />
                          </a>
                        </Row>
                      </Col>
                    </Row>
                </Grid>
            </Header>
        );
    }
}



// WEBPACK FOOTER //
// ./app/javascript/components/HomePage.jsx.erb